import { Moment } from 'moment';
import { IRangeFilter, IStringFilter } from 'app/shared/model/filter.model';

export interface IMessageTemplate {
  id?: number;
  title?: string;
  content?: string;
  createdAt?: Moment;
  createdBy?: string;
  updatedBy?: string;
  updatedAt?: Moment;
}

export const defaultValue: Readonly<IMessageTemplate> = {};

export interface ISearchForm {
  title?: IStringFilter;
  content?: IStringFilter;
  createdAt?: IRangeFilter;
  createdBy?: IStringFilter;
}

export const defaultSearchForm: ISearchForm = {
  createdAt: {
    lessOrEqualThan: '',
    lessThan: '',
    greaterOrEqualThan: '',
    greaterThan: ''
  },
  createdBy: { contains: '' },
  title: { contains: '' },
  content: { contains: '' }
};
